export default "__VITE_ASSET__Cjm0Exhe__"